import {
  Divider,
  Stack,
  Switch,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from '@mui/material';

import { Icon } from '@/components/shared/icon';

export const SecondaryIndexesSection = ({
  hasLSI,
  hasGSI,
  includeLSI,
  includeGSI,
  includeAllSecondaryIndexes,
  setIncludeLSI,
  setIncludeGSI,
  setIncludeAllSecondaryIndexes,
}: {
  hasLSI: boolean;
  hasGSI: boolean;
  includeLSI: boolean;
  includeGSI: boolean;
  includeAllSecondaryIndexes: boolean;
  setIncludeLSI: (value: boolean) => void;
  setIncludeGSI: (value: boolean) => void;
  setIncludeAllSecondaryIndexes: (value: boolean) => void;
}) => {
  return (
    <Stack className='w-full px-[40px]' gap='24px'>
      {hasGSI && hasLSI && (
        <Stack gap='24px'>
          <Stack
            direction='row'
            justifyContent='space-between'
            alignItems='center'
            className='group/allSecondaryIndexes'
          >
            <Typography className='font-semibold' variant='body1'>
              Include all secondary indexes
            </Typography>
            <Stack direction='row' alignItems='center' gap='8px'>
              <Tooltip
                title={
                  'Includes all secondary indexes — Global (GSI) and Local (LSI). Turn off to decide which ones to include or exclude.'
                }
              >
                <Icon
                  className='opacity-0 group-hover/allSecondaryIndexes:opacity-100 transition-opacity'
                  iconClass='material-symbols-help-outline-rounded'
                />
              </Tooltip>
              <Switch
                size='small'
                checked={includeAllSecondaryIndexes}
                onChange={() => {
                  setIncludeAllSecondaryIndexes(!includeAllSecondaryIndexes);
                }}
              />
            </Stack>
          </Stack>
          {!includeAllSecondaryIndexes && (
            <Stack gap='24px'>
              <Typography variant='body1' width='540px'>
                Choose which indexes to include. Excluding indexes can make the
                restore process faster.
              </Typography>
              <Stack
                gap='24px'
                divider={<Divider sx={{ borderStyle: 'dashed' }} />}
              >
                <Stack
                  direction='row'
                  justifyContent='space-between'
                  alignItems='center'
                >
                  <Typography variant='subtitle1'>
                    Global secondary indexes (GSI)
                  </Typography>
                  <ToggleButtonGroup
                    exclusive
                    value={includeGSI}
                    onChange={(e, value) => {
                      setIncludeGSI(value ?? false);
                    }}
                  >
                    <ToggleButton value={true}>Include</ToggleButton>
                    <ToggleButton value={false}>Exclude</ToggleButton>
                  </ToggleButtonGroup>
                </Stack>
                <Stack
                  direction='row'
                  justifyContent='space-between'
                  alignItems='center'
                >
                  <Typography variant='subtitle1'>
                    Local secondary indexes (LSI)
                  </Typography>
                  <ToggleButtonGroup
                    exclusive
                    value={includeLSI}
                    onChange={(e, value) => {
                      setIncludeLSI(value ?? false);
                    }}
                  >
                    <ToggleButton value={true}>Include</ToggleButton>
                    <ToggleButton value={false}>Exclude</ToggleButton>
                  </ToggleButtonGroup>
                </Stack>
              </Stack>
            </Stack>
          )}
        </Stack>
      )}
      {hasGSI && !hasLSI && (
        <Stack
          direction='row'
          justifyContent='space-between'
          alignItems='center'
        >
          <Typography className='font-semibold' variant='body1'>
            Include global secondary indexes (GSI)
          </Typography>
          <Switch
            size='small'
            checked={includeGSI}
            onChange={() => {
              setIncludeGSI(!includeGSI);
            }}
          />
        </Stack>
      )}
      {!hasGSI && hasLSI && (
        <Stack
          direction='row'
          justifyContent='space-between'
          alignItems='center'
        >
          <Typography variant='subtitle1'>
            Include local secondary indexes (LSI)
          </Typography>
          <Switch
            size='small'
            checked={includeLSI}
            onChange={() => {
              setIncludeLSI(!includeLSI);
            }}
          />
        </Stack>
      )}
    </Stack>
  );
};
